var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V36C12 37.6569 13.3431 39 15 39H33C34.6569 39 36 37.6569 36 36V16.2426C36 15.447 35.6839 14.6839 35.1213 14.1213L30.8787 9.87868C30.3161 9.31607 29.553 9 28.7574 9H15C13.3431 9 12 10.3431 12 12Z",
    fill: "#F56E76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 25C30.7761 25 31 25.2239 31 25.5C31 25.7761 30.7761 26 30.5 26L16.5 26C16.2239 26 16 25.7761 16 25.5C16 25.2239 16.2239 25 16.5 25L30.5 25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 28C30.7761 28 31 28.2239 31 28.5C31 28.7761 30.7761 29 30.5 29L16.5 29C16.2239 29 16 28.7761 16 28.5C16 28.2239 16.2239 28 16.5 28L30.5 28Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 17.1667C20.7677 17.1667 21.3895 16.5137 21.3895 15.7083C21.3895 16.5137 22.0114 17.1667 22.7784 17.1667C23.5455 17.1667 24.1673 16.5137 24.1673 15.7083L23.9086 14.9026C23.8279 14.5213 23.5058 14.25 23.1338 14.25H16.8675C16.4955 14.25 16.1734 14.5213 16.0927 14.9026L15.834 15.7083C15.834 16.5137 16.4558 17.1667 17.2229 17.1667C17.9899 17.1667 18.6118 16.5137 18.6118 15.7083C18.6118 16.5137 19.2336 17.1667 20.0007 17.1667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 20.9162V17.7708C16.5408 17.9168 16.8695 17.9996 17.2222 17.9996C17.7564 17.9996 18.2356 17.8097 18.6111 17.498C18.9866 17.8097 19.4658 17.9996 20 17.9996C20.5342 17.9996 21.0134 17.8097 21.3889 17.498C21.7644 17.8097 22.2436 17.9996 22.7778 17.9996C23.1305 17.9996 23.4592 17.9168 23.75 17.7708L23.75 20.9162C23.75 21.3765 23.3769 21.7496 22.9167 21.7496L17.0833 21.7496C16.6231 21.7496 16.25 21.3765 16.25 20.9162ZM20 19.2496C19.4247 19.2496 18.9583 19.7159 18.9583 20.2912V21.7496H21.0417V20.2912C21.0417 19.7159 20.5753 19.2496 20 19.2496Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31C22.7761 31 23 31.2239 23 31.5C23 31.7761 22.7761 32 22.5 32L16.5 32C16.2239 32 16 31.7761 16 31.5C16 31.2239 16.2239 31 16.5 31L22.5 31Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9C29.6403 9 30.2544 9.25435 30.7071 9.70711L35.2929 14.2929C35.7456 14.7456 36 15.3597 36 16H32C30.3431 16 29 14.6569 29 13V9Z",
    fill: "#C23143"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8438 31.6211L33.3793 35.1566L28.6452 36.7347C28.4107 36.8128 28.1875 36.5897 28.2657 36.3552L29.8438 31.6211Z",
    fill: "#111B48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0401 21.1925C41.552 20.7043 40.7666 20.6982 40.286 21.1789L29.8425 31.6223C31.521 33.3008 32.1528 33.9326 33.3781 35.1578L43.8215 24.7144C44.3021 24.2338 44.2961 23.4484 43.8079 22.9602L42.0401 21.1925Z",
    fill: "#111B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInfo);
export default __webpack_public_path__ + "static/media/edit-info.45cc44142725238155e254ed80e85305.svg";
export { ForwardRef as ReactComponent };